export default __webpack_public_path__ + "static/media/blue.a51b8ec7.gif";